import { Site } from '@common/config/api/client'

export function getPrimarySitePseudoId(sites: Array<Site>) {
  return sites.find((site) => site.site_association_type === 'PRIMARY_SITE')?.site_pseudo_id ?? ''
}
